import TrendsWrapper from '../shared/staffingContent/trends/TrendsWrapper';
import { Typography } from '@mui/material';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import CriticalPeriodsWrapper from '../shared/staffingContent/criticalPeriods/CriticalPeriodsWrapper';
import AssignmentsWrapper from '../shared/staffingContent/assignments/AssignmentsWrapper';
import NotesWrapper from '../shared/staffingContent/notes/NotesWrapper';
import StaffingTeamWrapper from '../shared/staffingContent/assignments/StaffingTeamWrapper';
import { ProjectSecurityContext } from 'domain/shared/newProject';
import { useShowContext } from 'framework/show';
import { DashboardItemSectionWrapper } from 'framework/ui/dashboard';
import { UpcomingChangesWrapper } from 'domain/shared/upcomingChanges';
import { ProjectHeatmapSection } from 'domain/shared/projectHeatmap';

const StaffingBottomContent = () => {
  const { isFeatureEnabled } = useFeatureToggle();
  const { data: project } = useShowContext();

  return (
    <ProjectSecurityContext permissions={project.accessInfo}>
      {isFeatureEnabled(Features.STAFFING_HEATMAP) && <ProjectHeatmapSection />}
      {isFeatureEnabled(Features.STAFFING_ASSIGNMENTS) ? <AssignmentsWrapper /> : <StaffingTeamWrapper />}
      {isFeatureEnabled(Features.PROJECT_CRITICAL_PERIODS_TEAM) && (
        <DashboardItemSectionWrapper
          title={
            <Typography variant="h4" color="primary">
              Project critical periods
            </Typography>
          }
          defaultExpanded
        >
          <CriticalPeriodsWrapper />
        </DashboardItemSectionWrapper>
      )}

      {isFeatureEnabled(Features.PROJECT_UPCOMING_CHANGES_TEAM) && <UpcomingChangesWrapper />}

      {isFeatureEnabled(Features.STAFFING_NOTES) && <NotesWrapper />}

      {isFeatureEnabled(Features.STAFFING_CHARTS) && (
        <DashboardItemSectionWrapper
          title={
            <Typography variant="h4" color="primary">
              Trends
            </Typography>
          }
          defaultExpanded
        >
          <TrendsWrapper />
        </DashboardItemSectionWrapper>
      )}
    </ProjectSecurityContext>
  );
};

export default StaffingBottomContent;
